import App from 'antd/lib/app';
import { useState } from 'react';
import { exportSiteRapsTemplate } from '../../domain/site-rap';

export const useDownloadSiteRapsTemplate = (companyId: number) => {
    const { notification } = App.useApp();
    const [isTemplateLoading, setIsTemplateLoading] = useState<boolean>(false);

    const downloadTemplate = async () => {
        if (!companyId) {
            notification.error({ key: 'site-raps-export-error', message: 'Company is missing' });
            return;
        }

        setIsTemplateLoading(true);

        try {
            await exportSiteRapsTemplate(companyId!);
        } catch (err: any) {
            notification.error({ key: 'site-raps-export-error', message: err.message || 'Cannot export site RAPs!' });
        }

        setIsTemplateLoading(false);
    };

    return {
        isTemplateLoading,
        downloadTemplate,
    };
};
